import { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useApp } from '@/hooks/use-app-context';
import { useTokenGuard } from './use-token-guard';
import { canAccessContributorWorkspace, homePathForRole, normalizeUserRole } from '@/lib/auth/roles';

interface ContributorRouteProps {
  children: ReactNode;
}

export function ContributorRoute({ children }: ContributorRouteProps) {
  const { user } = useApp();
  const { isValid } = useTokenGuard();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || 'fr';

  if (!isValid || !user) {
    return <Navigate to={`/${currentLang}/login`} state={{ from: window.location.pathname }} replace />;
  }

  // Admins, moderators and accountants only have their own panel.
  if (!canAccessContributorWorkspace(normalizeUserRole(user.role))) {
    return <Navigate to={homePathForRole(user.role, currentLang)} replace />;
  }

  return <>{children}</>;
}
